export const iconFontAwesomeTimeCalendar = (
	<i className="fa-solid fa-calendar"></i>
);
